/**
 * Belcopia Post-Add-to-Cart Upsell Modal
 * On a main product add-to-cart, opens a premium centered modal showing the
 * product's accessory upsells (reuses the "Complete Your Ride" section data).
 * Quick-add accessories without leaving the page; then continue to cart.
 */
(function () {
  'use strict';

  var suppress = false;        // set while we add from inside the modal
  var built = false;
  var overlay;

  function cartAddUrl() {
    return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';
  }

  // Collect accessory items from the dedicated modal data block (fuller list)
  function collectItems() {
    var src = document.querySelectorAll('.bc-cu-data__item');
    var items = [];
    src.forEach(function (el) {
      var img = el.getAttribute('data-img') || '';
      if (img && img.indexOf('{width}') > -1) img = img.replace('{width}', '500');
      var id = el.getAttribute('data-variant');
      if (!id) return;
      var variants = [];
      try { variants = JSON.parse(el.getAttribute('data-variants') || '[]') || []; } catch (err) { variants = []; }
      items.push({
        variants: variants,
        option: el.getAttribute('data-option') || '',
        variantId: id,
        handle: el.getAttribute('data-handle'),
        title: el.getAttribute('data-title') || '',
        url: el.getAttribute('data-url') || ('/products/' + (el.getAttribute('data-handle') || '')),
        price: el.getAttribute('data-price') || '',
        cents: el.getAttribute('data-price-cents') || '0',
        compare: el.getAttribute('data-compare') || '',
        img: img
      });
    });
    return items;
  }

  function inCartHandles() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.items || []).map(function (i) { return i.handle; }); })
      .catch(function () { return []; });
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var n = c.item_count;
        document.querySelectorAll('[data-cart-count], .cart-link__bubble-num, .cart-link__bubble, .site-header__cart-count').forEach(function (el) {
          if (el.hasAttribute('data-cart-count') || el.classList.contains('cart-link__bubble-num') || el.classList.contains('site-header__cart-count')) {
            el.textContent = n;
          }
          el.classList.add('cart-link__bubble--visible');
        });
      }).catch(function () {});
  }

  function closeModal() {
    if (overlay) overlay.classList.remove('bc-cu--open');
    document.documentElement.style.overflow = '';
  }

  function suppressThemeDrawer() {
    // Keep the Impulse cart drawer closed while our modal is showing
    [document.documentElement, document.body].forEach(function (n) {
      n.classList.remove('js-drawer-open', 'js-drawer-open--right', 'js-drawer-open--left');
    });
    var d = document.querySelector('.drawer--is-open');
    if (d) d.classList.remove('drawer--is-open');
  }

  // Roll each accessory up into a friendly customer-facing category
  // (mirrors gearCategoryOf in belcopia-upgrades.js so chips match across the flow)
  function categoryOf(it) {
    var s = ((it.title || '') + ' ' + (it.handle || '')).toLowerCase();
    if (/helmet/.test(s)) return 'Helmets';
    if (/lock/.test(s)) return 'Locks & Security';
    if (/light|mirror|reflector|bell|airtag/.test(s)) return 'Lights & Visibility';
    if (/saddle|seat-?post/.test(s)) return 'Saddles & Seating';
    if (/fork|suspension/.test(s)) return 'Suspension';
    if (/torque|sensor/.test(s)) return 'Performance';
    if (/child|trailer|pet|cushion/.test(s)) return 'Family & Cargo';
    if (/basket|frame.?bag|frame storage|handrail|rack|fender|pannier|fanny|storage|bag/.test(s)) return 'Storage & Racks';
    return 'More';
  }
  var CAT_ORDER = ['Saddles & Seating', 'Suspension', 'Performance', 'Lights & Visibility', 'Storage & Racks', 'Locks & Security', 'Helmets', 'Family & Cargo', 'More'];
  // The near-universal "every rider needs these" categories → essentials-first + bundle
  var ESSENTIAL_CATS = ['Helmets', 'Locks & Security', 'Lights & Visibility'];
  var MODAL_CAP = 3;            // cards shown by default in the "All" view

  // View state (reset on each build)
  var modalItems = [];
  var expanded = false;
  var currentCat = '*';
  var essentialPicks = [];
  var modalMoreCount = 0;

  function shortName(t) { return (t || '').replace(/^cyrusher\s+/i, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  // The chosen variant's name, for items that have a picker ('' otherwise)
  function chosenName(it) {
    if (!it.variants || it.variants.length < 2) return '';
    var v = it.variants.filter(function (x) { return String(x.id) === String(it.variantId); })[0];
    return v ? v.t : '';
  }

  var ESS_LABEL = { 'Helmets': 'Helmet', 'Locks & Security': 'Lock', 'Lights & Visibility': 'Lights' };
  function bundleText() {
    var sum = essentialPicks.reduce(function (t, p) { return t + (parseInt(p.cents || '0', 10) || 0); }, 0);
    var names = essentialPicks.map(function (p) {
      var n = ESS_LABEL[p.cat] || shortName(p.title), c = chosenName(p);
      return c ? n + ' (' + c + ')' : n;
    }).join(' + ');
    return { names: names, sum: sum };
  }

  function buildModal(items) {
    overlay = document.createElement('div');
    overlay.className = 'bc-cu';
    expanded = false;
    currentCat = '*';

    items.forEach(function (it) { it.cat = categoryOf(it); });

    // One essential per essential category (first found) → tagged "Most added", used for the bundle
    essentialPicks = [];
    ESSENTIAL_CATS.forEach(function (c) {
      var pick = items.filter(function (it) { return it.cat === c; })[0];
      if (pick) { pick.essential = true; essentialPicks.push(pick); }
    });

    // Order: essentials first (in ESSENTIAL_CATS order), then the rest by CAT_ORDER
    var rank = {};
    CAT_ORDER.forEach(function (c, i) { rank[c] = i; });
    items.sort(function (a, b) {
      if (a.essential && !b.essential) return -1;
      if (b.essential && !a.essential) return 1;
      if (a.essential && b.essential) return ESSENTIAL_CATS.indexOf(a.cat) - ESSENTIAL_CATS.indexOf(b.cat);
      return (rank[a.cat] == null ? 99 : rank[a.cat]) - (rank[b.cat] == null ? 99 : rank[b.cat]);
    });

    var present = CAT_ORDER.filter(function (c) { return items.some(function (it) { return it.cat === c; }); });
    var chips = '<button type="button" class="bc-cu__chip bc-cu__chip--active" data-cat="*">All</button>' +
      present.map(function (c) { return '<button type="button" class="bc-cu__chip" data-cat="' + c + '">' + c + '</button>'; }).join('');

    modalItems = items;
    var cards = items.map(function (it, i) {
      var compare = it.compare ? '<span class="bc-cu__compare">' + it.compare + '</span>' : '';
      var imgHtml = it.img ? '<img class="bc-cu__img" src="' + it.img + '" alt="' + it.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '<div class="bc-cu__img bc-cu__img--ph"></div>';
      var badge = it.essential ? '<span class="bc-cu__badge">Most added</span>' : '';
      var picker = '';
      if (it.variants && it.variants.length > 1) {
        picker = '  <select class="bc-cu__variant" aria-label="' + esc((it.option || 'Option') + ' for ' + it.title) + '"' +
          ' style="display:block;width:100%;margin:6px 0 8px;padding:6px 8px;font-size:16px;line-height:1.2;border:1px solid #ccc;border-radius:6px;background:#fff;color:#111;">' +
          it.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (String(v.id) === String(it.variantId) ? ' selected' : '') + (v.a ? '' : ' disabled') + '>' +
              esc(v.t) + (v.a ? '' : ' (sold out)') + '</option>';
          }).join('') +
          '</select>';
      }
      return '' +
        '<div class="bc-cu__card" data-variant="' + it.variantId + '" data-cat="' + it.cat + '" data-idx="' + i + '">' +
        badge +
        '  <a class="bc-cu__imglink" href="' + it.url + '" target="_blank" rel="noopener">' + imgHtml + '</a>' +
        '  <a class="bc-cu__title" href="' + it.url + '" target="_blank" rel="noopener">' + it.title + '</a>' +
        '  <div class="bc-cu__price">' + compare + '<span class="bc-cu__now">' + it.price + '</span></div>' +
        picker +
        '  <button type="button" class="bc-cu__add" data-variant="' + it.variantId + '">Add to cart</button>' +
        '</div>';
    }).join('');

    // One-tap "Gear up" bundle (only when there are ≥2 essentials); names the chosen colour
    var bundleHtml = '';
    if (essentialPicks.length >= 2) {
      var bt = bundleText();
      bundleHtml =
        '<div class="bc-cu__bundle">' +
        '  <div class="bc-cu__bundle-info">' +
        '    <span class="bc-cu__bundle-label">Gear up — add the essentials</span>' +
        '    <span class="bc-cu__bundle-names">' + esc(bt.names) + '</span>' +
        '  </div>' +
        '  <button type="button" class="bc-cu__bundle-btn" data-bc-bundle>Add all · $' + (bt.sum / 100).toFixed(2) + '</button>' +
        '</div>';
    }

    modalMoreCount = items.length - MODAL_CAP;
    var seeAllHtml = (items.length > MODAL_CAP)
      ? '<button type="button" class="bc-cu__seeall" data-bc-seeall>See all gear (' + modalMoreCount + ' more) &rsaquo;</button>'
      : '';

    overlay.innerHTML = '' +
      '<div class="bc-cu__backdrop" data-bc-close></div>' +
      '<div class="bc-cu__dialog" role="dialog" aria-modal="true" aria-label="Complete your ride">' +
      '  <button type="button" class="bc-cu__x" data-bc-close aria-label="Close">&times;</button>' +
      '  <div class="bc-cu__head">' +
      '    <div class="bc-cu__check">&#10003;</div>' +
      '    <div>' +
      '      <p class="bc-cu__added">Added to your cart</p>' +
      '      <h2 class="bc-cu__heading">Complete your ride</h2>' +
      '      <p class="bc-cu__sub">Riders often add these to get the most out of their bike.</p>' +
      '    </div>' +
      '  </div>' +
      bundleHtml +
      (present.length > 1 ? '  <div class="bc-cu__chips">' + chips + '</div>' : '') +
      '  <div class="bc-cu__scroller">' + cards + '</div>' +
      seeAllHtml +
      '  <div class="bc-cu__foot">' +
      '    <a class="bc-cu__cta" href="/cart">View cart &amp; check out</a>' +
      '    <button type="button" class="bc-cu__keep" data-bc-close>No thanks, keep shopping</button>' +
      '  </div>' +
      '</div>';

    document.body.appendChild(overlay);
    applyView();

    overlay.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-bc-close')) { closeModal(); return; }
      if (e.target.closest('[data-bc-seeall]')) { expanded = !expanded; applyView(); return; }
      if (e.target.closest('[data-bc-bundle]')) { addBundle(e.target.closest('[data-bc-bundle]')); return; }
      var chip = e.target.closest('.bc-cu__chip');
      if (chip) { filterCat(chip); return; }
      var add = e.target.closest('.bc-cu__add');
      if (add) { quickAdd(add); }
    });
    overlay.addEventListener('change', function (e) {
      var sel = e.target;
      if (!sel.classList || !sel.classList.contains('bc-cu__variant')) return;
      var card = sel.closest('.bc-cu__card');
      var it = card && modalItems[parseInt(card.getAttribute('data-idx'), 10)];
      if (!it) return;
      var v = it.variants.filter(function (x) { return String(x.id) === sel.value; })[0];
      if (!v) return;
      it.variantId = String(v.id);
      it.cents = String(v.c);
      it.price = v.p;
      card.setAttribute('data-variant', it.variantId);
      var btn = card.querySelector('.bc-cu__add');
      if (btn) {
        btn.setAttribute('data-variant', it.variantId);
        btn.classList.remove('bc-cu__add--done');
        btn.disabled = false;
        btn.textContent = 'Add to cart';
      }
      var now = card.querySelector('.bc-cu__now');
      if (now) now.textContent = v.p;
      var bn = overlay.querySelector('.bc-cu__bundle-names'), bb = overlay.querySelector('[data-bc-bundle]');
      if (bn && bb && !bb.classList.contains('bc-cu__bundle-btn--done')) {
        var bt = bundleText();
        bn.textContent = bt.names;
        bb.textContent = 'Add all · $' + (bt.sum / 100).toFixed(2);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('bc-cu--open')) closeModal();
    });
    built = true;
  }

  // Show/hide cards by current category + the cap (cap only applies in "All", unexpanded)
  function applyView() {
    if (!overlay) return;
    overlay.querySelectorAll('.bc-cu__card').forEach(function (card) {
      var matchesCat = (currentCat === '*' || card.getAttribute('data-cat') === currentCat);
      var idx = parseInt(card.getAttribute('data-idx'), 10);
      var underCap = (currentCat !== '*') || expanded || idx < MODAL_CAP;
      card.style.display = (matchesCat && underCap) ? '' : 'none';
    });
    var seeall = overlay.querySelector('[data-bc-seeall]');
    if (seeall) {
      seeall.style.display = (currentCat === '*') ? '' : 'none';
      seeall.innerHTML = expanded ? 'See less &lsaquo;' : ('See all gear (' + modalMoreCount + ' more) &rsaquo;');
    }
  }

  function filterCat(chip) {
    currentCat = chip.getAttribute('data-cat');
    overlay.querySelectorAll('.bc-cu__chip').forEach(function (c) { c.classList.toggle('bc-cu__chip--active', c === chip); });
    applyView();
    var sc = overlay.querySelector('.bc-cu__scroller');
    if (sc) sc.scrollLeft = 0;
  }

  // Add all not-yet-added essentials in one request
  function addBundle(btn) {
    var toAdd = essentialPicks.filter(function (p) {
      var ab = overlay.querySelector('.bc-cu__card[data-variant="' + p.variantId + '"] .bc-cu__add');
      return ab && !ab.classList.contains('bc-cu__add--done');
    });
    if (!toAdd.length) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    suppress = true;
    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: toAdd.map(function (p) { return { id: parseInt(p.variantId, 10), quantity: 1 }; }) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        toAdd.forEach(function (p) {
          var ab = overlay.querySelector('.bc-cu__card[data-variant="' + p.variantId + '"] .bc-cu__add');
          if (ab) { ab.textContent = 'Added ✓'; ab.classList.add('bc-cu__add--done'); ab.disabled = true; }
        });
        btn.textContent = 'Essentials added ✓';
        btn.classList.add('bc-cu__bundle-btn--done');
        updateCartCount();
        setTimeout(function () { suppress = false; }, 300);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add all';
        suppress = false;
      });
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant');
    if (!id || btn.classList.contains('bc-cu__add--done')) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    suppress = true;
    fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.add('bc-cu__add--done');
        updateCartCount();
        setTimeout(function () { suppress = false; }, 300);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
        suppress = false;
      });
  }

  function openFor() {
    var items = collectItems();
    if (!items.length) return;
    inCartHandles().then(function (have) {
      var fresh = items.filter(function (it) { return have.indexOf(it.handle) === -1; });
      if (!fresh.length) return;            // everything already in cart — skip
      if (!built) buildModal(fresh);
      else {
        // refresh grid contents
        var grid = overlay.querySelector('.bc-cu__grid');
        if (grid) {
          // rebuild only if set changed
          built = false; overlay.remove(); buildModal(fresh);
        }
      }
      suppressThemeDrawer();
      requestAnimationFrame(function () {
        overlay.classList.add('bc-cu--open');
        document.documentElement.style.overflow = 'hidden';
      });
      // catch the theme trying to open the drawer a tick later
      setTimeout(suppressThemeDrawer, 60);
      setTimeout(suppressThemeDrawer, 220);
    });
  }

  document.addEventListener('ajaxProduct:added', function (e) {
    if (suppress) return;
    // ignore adds that came from upsell/quick-add buttons (not the main product)
    var origin = e.detail && e.detail.addToCartBtn;
    if (origin && origin.closest && origin.closest('.belcopia-upsells, .cart-upsells, .bc-cu')) return;
    openFor();
  });

})();
